var $ = jQuery.noConflict();

$(window).on('load', function () {
    let method = 'front';
    if ($('body').hasClass('wp-admin'))
        method = 'wp-admin';

        var initializeBlock = function ($block) {
            const swipers = $('.block-text-card-slider');
            const swipersArrayCards = [];
            let counter = 0;
            let current = 0;

            swipers.each(function(){
                const index = $(this).index();

                const swiper = $('.text-card-swiper-container',$(this));
                swiper.addClass('text-card-swiper-container--' + index);

                const prev = $('.swiper-button-prev', $(this));
                prev.addClass('swiper-button-prev--' + index);
                const next = $('.swiper-button-next', $(this));
                next.addClass('swiper-button-next--' + index);

                swipersArrayCards[counter] = new Swiper('.text-card-swiper-container--' + index, {
                    slidesPerView: "auto",
                    //centeredSlides: true,
                    slidesPerSlide: 1,
                    speed: 400,
                    spaceBetween: 20,
                    initialSlide: 0,
                    resistanceRatio: 0,
                    navigation: {
                        nextEl: '.swiper-button-next--' + index,
                        prevEl: '.swiper-button-prev--' + index,
                    },
                    on: {
                        init: function(){
                            //setPosition();
                        },
                        slideChange: function () {
                        },
                        transitionEnd: function() {
                            // const elementleft = $('.text-card-swiper-container--' + index + ' .swiper-slide').last().offset().left + $('.text-card-swiper-container--' + index + ' .swiper-slide').last().width();
                            // if (elementleft <= $(window).width()) {
                            //     if (!$('.block-text-card-slider--sustainability').length) {
                            //         $('.swiper-button-next--' + index).addClass('swiper-button-disabled');
                            //         this.allowSlideNext = false;
                            //     }
                            // } else {
                            //     if (!$('.block-text-card-slider--sustainability').length) {
                            //         $('.swiper-button-next--' + index).removeClass('swiper-button-disabled');
                            //         this.allowSlideNext = true;
                            //     }
                            // }
                        }
                    },
                });

                counter++;
            });

            $('.swiper-button-next').on('click', function(e) {
                e.preventDefault();
                return false;
            });

            $(window).on('resize',function(){
                //setPosition();
            });
    };

    window.onload = function () {
        initializeBlock($(this));
    }();

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=text-card-slider', initializeBlock);
    }
});
